import React from 'react';
import { BaseConfig } from '../BaseConfig';
import { UIProperties } from '../UIProperties';

import './ResumeUI.css'

const ResumeUI = (props: UIProperties<ResumeUIConfig>) => {
	return (
		<div className="in-game-ui-container ui-top-most-container">
			<div>
			</div>
			
		</div>
	);

};

export interface ResumeUIConfig extends BaseConfig {
	onResumeClicked: () => void;
	onStartOverClicked: () => void;
}

export default ResumeUI;